export interface RawImageData {
  alternativeText?: string
  name?: string
  url?: string
  width?: number
  height?: number
}

export interface NormalizedImageData {
  alt: string | undefined
  src: string | undefined
  width: number | undefined
  height: number | undefined
}

const normalizeImage = (rawData: RawImageData): NormalizedImageData => {
  const normalizedData: NormalizedImageData = {
    alt: rawData?.alternativeText || rawData?.name,
    src: rawData?.url,
    width: rawData?.width,
    height: rawData?.height,
  }

  return normalizedData
}

export default normalizeImage